import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';


const useStyles = makeStyles((theme) => ({
    carddiv: {
        maxWidth: 545,
        width: 240,
        margin: 10,
        background: "black",
        '@media (min-width:600px)': {
            width: 590,
        },
    },
    para: {
        fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, 
        sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
        color: '#ccc',
        lineHeight: '1.5',
        fontWeight: 300,
        fontSize: '1rem',
        textAlign: 'center',
        margin: theme.spacing(2),
        '@media (min-width:600px)': {
            fontSize: '1.2rem',
        },
        '@media (min-width:1200px)': {
            fontSize: '1.4rem',
        },
    },
    cardbtn: {
        color: "orange",
        '@media (min-width:600px)': {
            fontSize: '1rem',
        },
        '@media (min-width:1024px)': {
            fontSize: '1.2rem',
        },
    },
    media: {
        height: '350',
        borderRadius: '4%',
    },
    cardtitle: {
        fontSize: '1rem',
        textAlign: 'center',
        paddingTop: '2rem',
        color: "orange",
        '@media (min-width:600px)': {
            fontSize: '1.5rem',
        },
    },
    action: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
    },
}));

const Projectcard = ({ title, image, description, builtwith, github, deployed }) => {
    const classes = useStyles();

    return (
        <Card className={classes.carddiv}>
            <CardMedia
                component="img"
                rel="preload"
                as="image"
                alt="project image"
                className={classes.media}
                image={image}
                title="Projects done by me"
            />
            <CardContent className={classes.cardbody}>
                <Typography gutterBottom className={classes.cardtitle} component="h2">
                    {title}
                </Typography>
                <Typography component="p" className={classes.para} >
                    Description: {description}
                </Typography>
                <Typography component="p" className={classes.para}>
                    Built With: {builtwith}
                </Typography>
            </CardContent>
            <CardActions className={classes.action}>
                <Button
                    className={classes.cardbtn}
                    aria-label="GitHub"
                    target="_blank"
                    variant="outlined"
                    endIcon={<DoubleArrowIcon />}
                    rel="noopener"
                    href={github}>
                    GitHub
                </Button>
                <Button
                    className={classes.cardbtn}
                    aria-label="deployed/demo"
                    target="_blank"
                    variant="outlined"
                    endIcon={<DoubleArrowIcon />}
                    rel="noopener"
                    href={deployed}>
                    App / Demo
                </Button>
            </CardActions>
        </Card>
    )
}

export default Projectcard

